import {
  actions,
  getEventKeyMappingsDatatableAsync,
  getEventKeyMappingByIdAsync,
  editEventKeyMappingAsync,
  changeEventKeyMappingPublishingStateAsync,
} from './slices';

export const EventKeyMappingsActions = {
  ...actions,
  getEventKeyMappingsDatatableAsync,
  getEventKeyMappingByIdAsync,
  editEventKeyMappingAsync,
  changeEventKeyMappingPublishingStateAsync,
};
